module.exports = flarum.core.compat['components/DashboardPage'];